import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { applyTheme, getTheme, applyAccent, getAccent } from './utils/theme';

// Apply the persisted/URL-selected theme + accent before first paint (reversible).
applyTheme(getTheme());
applyAccent(getAccent());

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
